<template> </template>

<script>
import {
  BRow,
  BCol,
  BLink,
  BCard,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BCardText,
} from "bootstrap-vue";

import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BCardText,
  },
  props: {},
  data() {
    return {};
  },
  mounted() {
    const roleId = userData.selectedUserRole().value.toUpperCase();
    console.log("dashboard-fasttrack-role .roleId", roleId)
    // this.$router.push({
    //   name: "dashboard-statistic-fasttrack-role",
    // });
    // this.$router.push({
    //   name: "dashboard-fasttrack-role-screening",
    // });

    // คัดกรอง
    if (roleId === "11857BDF-5691-45F1-823E-F5C3A6FD9FF4") {
      this.$router.push({
        name: "dashboard-fasttrack-role-screening",
      });
    } // ธุรการกอง
    else if (
      roleId === "6F1AACD6-2EBA-4FB7-ABA2-02569990E5F4" ||
      roleId === "5022359E-B754-4C7A-9B56-BB2E44ADAC2E" ||
      roleId === "9986F72B-D167-4532-8C27-4BC183EF5222"
    ) {
      this.$router.push({
        name: "dashboard-fasttrack-role-admin",
      });
    }
    // // หัวหน้าฝ่าย/ผอ.
    // else if (
    //   roleId === "D89014C0-BDB1-46AF-8978-1BB44ED8C7AB" ||
    //   roleId === "F9D5BCB6-A54A-4FD6-BC6C-7A4040FE61AC" ||
    //   roleId === "B44AB512-8847-4E5E-A0A9-E4454C86D847"
    // ) {
    //   this.$router.push({
    //     name: "dashboard-statistic-dept-leader-director",
    //   });
    // }
    // เจ้าหน้าที่กอง
    else if (
      roleId === "5B70388F-7208-4F0A-BF76-F4D7DE349E92" ||
      roleId === "785FB022-61FF-4B43-BD90-32DD78EFAFB7"
    ) {
      this.$router.push({
        name: "dashboard-fasttrack-role-officer",
      });
    }
    // // เจ้าหน้าที่จังหวัด
    // else if (roleId === "25E8AF7C-D072-47FD-985B-FB1EEFC44764") {
    //   this.$router.push({
    //     name: "dashboard-statistic-provincial-officials",
    //   });
    // }
  },
  methods: {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>